<template>
  <div class="admin-sidebar">
    <div
      class="logo-container d-flex align-items-center justify-content-between"
      style="padding: 1.25rem 1.5rem"
    >
      <img
        src="/images/tgs_logo_1.png"
        alt="TGS Logo"
        style="height: 40px; width: auto; object-fit: contain"
      />
      <span
        class="logo-text text-white mb-0"
        style="font-size: 1.1rem; font-weight: 700"
        >ADMIN PANEL</span
      >
    </div>

    <ul class="nav-menu">
      <li v-for="(menu, index) in filteredMenus" :key="index">
        <router-link v-if="!menu.children" :to="menu.path">
          <i :class="menu.icon"></i> {{ menu.name }}
        </router-link>

        <div v-else class="menu-item-toggle" @click="toggleMenu(index)">
          <span><i :class="menu.icon"></i> {{ menu.name }}</span>
          <i
            class="bi bi-chevron-down arrow-icon"
            :class="{ rotated: openMenuIndex === index }"
          ></i>
        </div>

        <ul
          v-if="menu.children"
          class="submenu"
          v-show="openMenuIndex === index"
        >
          <li v-for="(submenu, subIndex) in menu.children" :key="subIndex">
            <router-link :to="submenu.path">
              {{ submenu.name }}
            </router-link>
          </li>
        </ul>
      </li>

      <li class="logout-item">
        <div @click="logout" class="menu-item-toggle">
          <span><i class="bi bi-box-arrow-right"></i> Logout</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { useAdminAuthStore } from "@/stores/adminAuthStore";

export default {
  name: "AdminSidebar",
  data() {
    return {
      openMenuIndex: null,
      menus: [
        {
          name: "Dashboard (BI)",
          icon: "bi bi-speedometer2",
          path: "/",
          permission: "view_dashboard",
        },
        {
          name: "ข้อมูลบริษัท",
          icon: "bi bi-building",
          children: [
            {
              name: "ข้อมูลทั่วไป (Profile)",
              path: "/admin/company-info",
              permission: "view_company_profile",
            },
            {
              name: "บัญชีธนาคาร บริษัท",
              path: "/admin/company/bank-accounts",
              permission: "view_company_bank",
            },
            {
              name: "จัดการระบบ Admin",
              path: "/admin/users",
              permission: "manage_admins",
            },
            {
              name: "ข้อมูลพนักงาน (RBAC)",
              path: "/admin/staff",
              permission: "manage_roles",
            },
          ],
        },
        {
          name: "การจัดการสมาชิก",
          icon: "bi bi-people-fill",
          children: [
            {
              name: "ค้นหาสมาชิก",
              path: "/members",
              permission: "view_members",
            },
            {
              name: "เข้าหน้าสมาชิก",
              path: "/admin/impersonate",
              permission: "impersonate_member",
            },
            {
              name: "ขยายเวลาพิเศษ Fast Start/Quick Star",
              path: "/admin/bonus-window-override",
              permission: "manage_bonus_window_override",
            },
            {
              name: "จัดการแบนเนอร์ QR สปอนเซอร์",
              path: "/admin/banner-templates",
              permission: "manage_banner_templates",
            },
            // 🆕 (12 ต.ค. 2569) ตรวจ/อนุมัติเรื่องราวสมาชิกที่ใช้แสดงในหน้าเปิดใจผู้มุ่งหวัง
            {
              name: "อนุมัติเรื่องราวสมาชิก",
              path: "/admin/member-stories",
              permission: "manage_member_stories",
            },
            // 🆕 (14 ต.ค. 2569) ตั้งค่าหน้าเปิดใจผู้มุ่งหวัง (ข้อความ คำถาม สินค้า AI การจับคู่)
            {
              name: "ตั้งค่าหน้าเปิดใจผู้มุ่งหวัง",
              path: "/admin/prospect-page-settings",
              permission: "manage_prospect_page_settings",
            },
          ],
        },
        {
          name: "การจัดการสินค้าและคลังสินค้าบริษัท",
          icon: "bi bi-box-seam",
          children: [
            {
              name: "ฐานข้อมูลคลังสินค้า",
              path: "/inventory/master",
              permission: "view_inventory_master",
            },
            {
              name: "หน้าจัดการสินค้า",
              path: "/products",
              permission: "manage_products",
            },
            {
              name: "รับสินค้าเข้า Stock",
              path: "/inventory/receive-notes",
              permission: "manage_stock_in",
            },
            {
              name: "เบิกสินค้าออกจาก Stock",
              path: "/inventory/stock-adjustment",
              permission: "manage_stock_out",
            },
            {
              name: "สมุดบัญชี Stock",
              path: "/inventory/ledger",
              permission: "view_inventory_ledger",
            },
          ],
        },
        {
          name: "Mobile ตัวแทน",
          icon: "bi bi-shop",
          children: [
            {
              // 🆕 (27 ก.ค. 2569) แทนที่เมนู Stockist เดิม (ยังไม่เคยพัฒนาใช้งานจริง) ด้วยหน้าแต่งตั้งตัวแทน Mobile/Center
              name: "แต่งตั้งตัวแทน Mobile/Center",
              path: "/admin/agent-appointment",
              permission: "manage_stockist",
            },
          ],
        },
        {
          name: "การจัดการคำสั่งซื้อ",
          icon: "bi bi-receipt",
          children: [
            {
              name: "การจัดส่งสินค้า",
              path: "/admin/shipping",
              permission: "manage_shipping",
            },
            {
              name: "รายการคำสั่งซื้อ",
              path: "/admin/orders/list",
              permission: "view_orders",
            },
            {
              name: "รายการแจงยอด",
              path: "/admin/allocations/list",
              permission: "view_allocations",
            },
          ],
        },
        {
          name: "การเงิน / Wallet",
          icon: "bi bi-wallet2",
          children: [
            {
              name: "เติมเงิน E-Wallet",
              path: "/admin/wallet/approve",
              permission: "approve_wallet_topup",
            },
            {
              name: "สมาชิกถอนเงิน",
              path: "/admin/wallet/withdraw",
              permission: "approve_wallet_withdraw",
            },
            {
              name: "ประวัติระบบ Wallet",
              path: "/admin/wallet/history",
              permission: "view_wallet_history",
            },
            {
              name: "ระบบโอนเงินรอบ 5 วัน",
              path: "/admin/payout",
              permission: "manage_payout",
            },
            {
              name: "บัญชี Wallet บริษัท",
              path: "/admin/wallet/company-overview",
              permission: "view_wallet_company-overview",
            },
            {
              name: "จัดการ TGS Point",
              path: "/admin/tgs-report",
              permission: "manage_tgs_point",
            },
          ],
        },
        {
          name: "Promotions",
          icon: "bi bi-gift-fill",
          children: [
            {
              name: "จัดการ Promotions",
              path: "/admin/promotions",
              permission: "manage_promotion",
            },
            {
              name: "จัดการคูปองส่วนลด",
              path: "/admin/coupons",
              permission: "manage_promotion",
            },
            {
              name: "Company Ledgers",
              path: "/admin/finance/ledgers",
              permission: "finance_ledger",
            },
          ],
        },
        {
          name: "โบนัสรายเดือน Loyalty, Saving",
          icon: "bi bi-calendar-heart",
          children: [
            {
              name: "Leadership Bonus",
              path: "/admin/leadership-report",
              permission: "Leadership_Bonus",
            },
            {
              name: "Team Builder Bonus",
              path: "/admin/team-builder-report",
              permission: "Team_Builder_Bonus",
            },
            {
              name: "All Sale Bonus",
              path: "/admin/all-sale-report",
              permission: "All_Sale_Bonus",
            },
            {
              name: "รายงาน Loyalty Bonus",
              path: "/admin/loyalty-report",
              permission: "manage_loyalty",
            },
            {
              name: "ภาพรวม Saving Bonus",
              path: "/admin/saving-report",
              permission: "view_saving",
            },
            {
              name: "จัดการคำขอถอน Saving Bonus",
              path: "/admin/saving-withdrawals",
              permission: "view_saving",
            },
            {
              name: "ระบบ Top Sponsor",
              path: "/admin/top-sponsor-report",
              permission: "Top_Sponsor",
            },
          ],
        },
        {
          name: "Work Plan",
          icon: "bi bi-calendar-check",
          children: [
            {
              name: "ตั้งค่าบันได 8 ขั้น",
              path: "/admin/workplan/steps",
              permission: "manage_workplan",
            },
            {
              name: "จัดการรอบประชุม",
              path: "/admin/workplan/meeting",
              permission: "manage_meeting",
            },
            {
              name: "6 Start Up",
              path: "/admin/startup",
              permission: "manage_startup",
            },
            {
              name: "Star 14-2-7",
              path: "/admin/workplan/events",
              permission: "manage_events",
            },
            {
              name: "Skill Mindset",
              path: "/admin/workplan/growth-system",
              permission: "manage_growth",
            },
          ],
        },
        {
          name: "AI Chatbot",
          icon: "bi bi-robot",
          children: [
            {
              name: "Giver AI Manager",
              path: "/admin/giver-ai/manager",
              permission: "manage_ai_member",
            },
            {
              name: "AI Admin (Query)",
              path: "/admin/ai/admin-query",
              permission: "use_ai_admin",
            },
          ],
        },
        {
          name: "Communication Tools",
          icon: "bi bi-broadcast",
          children: [
            {
              name: "สร้างข่าวสารรายวัน",
              path: "/admin/communication/announcements",
              permission: "manage_announcement",
            },
            {
              name: "Notification/Email",
              path: "/admin/comms/email",
              permission: "manage_email",
            },
            {
              name: "Notification Line",
              path: "/admin/comms/line",
              permission: "manage_line",
            },
          ],
        },
        {
          name: "CEO",
          icon: "bi bi-person-badge",
          children: [
            {
              name: "ตั้งค่าแผนการจ่าย",
              path: "/admin/comp-plan-settings",
              permission: "ceo_comp_plan",
            },
            {
              name: "วิเคราะห์งบการเงิน",
              path: "/admin/financial/dashboard",
              permission: "ceo_finance",
            },
            {
              name: "Funnel System",
              path: "/admin/funnel-analytics",
              permission: "ceo_funnel",
            },
            // 🆕 (14 ต.ค. 2569) รายงานหน้าเปิดใจผู้มุ่งหวัง (เฟส 5)
            {
              name: "หน้าเปิดใจผู้มุ่งหวัง",
              path: "/admin/prospect-page-analytics",
              permission: "ceo_prospect_page",
            },
            {
              name: "6 start up AS",
              path: "/admin/startup-analytics",
              permission: "ceo_startup",
            },
            {
              name: "เป้าหมาย 4 มิติ",
              path: "/admin/ceo/goals",
              permission: "ceo_goals",
            },
            {
              name: "แผนงาน",
              path: "/admin/ceo/plans",
              permission: "ceo_plans",
            },
            {
              name: "แผงควบคุมระบบ",
              path: "/admin/system-tools",
              permission: "system_tools",
            },
          ],
        },
      ],
    };
  },
  computed: {
    // ดึงพวงกุญแจ (Array) ของแอดมินที่ล็อกอินอยู่มาจาก Store
    userPermissions() {
      const authStore = useAdminAuthStore();
      return authStore.user?.permissions || [];
    },
    // กรองเมนูทั้งหมดโดยอัตโนมัติ
    filteredMenus() {
      const authStore = useAdminAuthStore();
      // ถ้าเป็น Super Admin (role_id = 1) ให้เห็นทุกเมนูเลยเพื่อความชัวร์ ป้องกันการล็อกตัวเองตาย
      if (authStore.user?.role_id === 1) {
        return this.menus;
      }

      // ถ้าเป็นตำแหน่งอื่นๆ ให้เริ่มทำการกรอง
      return this.menus
        .map((menu) => {
          // กรณีเป็นเมนูเดี่ยวๆ ไม่มีเมนูลูก
          if (!menu.children) {
            return this.userPermissions.includes(menu.permission) ? menu : null;
          }
          // กรณีมีเมนูลูก (Dropdown)
          else {
            const filteredChildren = menu.children.filter((child) =>
              this.userPermissions.includes(child.permission),
            );
            // ถ้ากรองแล้วยังมีเมนูลูกเหลืออยู่ ค่อยโชว์เมนูหลัก
            if (filteredChildren.length > 0) {
              return { ...menu, children: filteredChildren };
            }
            return null; // ซ่อนเมนูหลักทิ้งไปเลย ถ้าไม่มีลูกเหลือ
          }
        })
        .filter((menu) => menu !== null); // ตัดค่าว่างทิ้ง
    },
  },
  methods: {
    toggleMenu(index) {
      if (this.openMenuIndex === index) {
        this.openMenuIndex = null;
      } else {
        this.openMenuIndex = index;
      }
    },
    logout() {
      if (confirm("คุณต้องการออกจากระบบ Admin หรือไม่?")) {
        const authStore = useAdminAuthStore();
        authStore.logout();
      }
    },
  },
};
</script>

<style scoped>
/* (ธีมสีเทาเข้มของ Admin - คงเดิม) */
.admin-sidebar {
  width: 250px;
  background-color: #343a40;
  color: white;
  position: sticky;
  top: 0;
  height: 100vh;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}
.logo-container {
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #495057;
}
.logo-text {
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
}

/* (Scrollbar - นำมาจาก Member Sidebar) */
.nav-menu {
  list-style: none;
  padding: 1rem;
  margin: 0;
  flex-grow: 1;
  overflow-y: auto;
  height: calc(100% - 80px);
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
}
.nav-menu::-webkit-scrollbar {
  width: 8px;
}
.nav-menu::-webkit-scrollbar-track {
  background: transparent;
}
.nav-menu::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  border: 2px solid transparent;
  background-clip: content-box;
}
.nav-menu::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.5);
}

/* (สไตล์เมนูหลัก - ปรับจาก Member ให้เป็นธีม Admin) */
.nav-menu a,
.menu-item-toggle {
  color: #adb5bd;
  text-decoration: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  border-radius: 0.375rem;
  margin-bottom: 0.25rem;
  transition: all 0.2s;
  font-weight: 500;
  cursor: pointer;
}
.nav-menu a:hover,
.menu-item-toggle:hover {
  background-color: #495057;
  color: white;
}
.nav-menu i {
  margin-right: 0.75rem;
}

/* (สไตล์หน้า Active - ธีม Admin) */
.nav-menu a.router-link-exact-active {
  background-color: #0d7579; /* (สีเขียวธีม) */
  color: white;
  font-weight: 700;
}

/* [GEMINI EDIT] - CSS ใหม่สำหรับ Dropdown (จาก Member) */
.arrow-icon {
  transition: transform 0.3s ease;
  font-size: 0.8rem;
  color: #ffffff; /* บังคับเป็นสีขาว */
  opacity: 0.6; /* ทำให้จางลงเล็กน้อย (ถ้าคุณอยากให้มันสว่าง 100% ให้ลบบรรทัดนี้) */
}
.arrow-icon.rotated {
  transform: rotate(180deg);
}
.submenu {
  list-style: none;
  padding: 5px 0 10px 0;
  overflow: hidden;
}
.submenu a {
  display: block;
  padding: 0.6rem 1rem 0.6rem 2.6rem; /* (ย่อหน้าเข้ามา) */
  font-size: 0.9rem;
  font-weight: 400;
  color: #adb5bd; /* (สีเทาอ่อน) */
  border-radius: 0.375rem;
}
.submenu a:hover {
  background-color: #495057;
  color: white;
}
.submenu a.router-link-exact-active {
  color: #ffffff;
  font-weight: 600;
}

/* (ปุ่ม Logout - ธีม Admin) */
.logout-item {
  margin-top: auto;
}
.logout-item .menu-item-toggle:hover {
  background-color: rgba(220, 53, 69, 0.5); /* (สีแดงเมื่อ Hover) */
  color: white;
}
@media (max-width: 992px) {
  .admin-sidebar {
    /* (1. เปลี่ยนเป็น 'fixed' เพื่อให้ลอยได้) */
    position: fixed;
    /* (2. z-index ต้องสูงที่สุด (สูงกว่า Overlay)) */
    z-index: 1000;
    /* (3. ซ่อนไว้ด้านซ้าย) */
    left: -250px;
    transition: left 0.3s ease-in-out;
  }

  /* (4. เมื่อ App.vue มีคลาส 'sidebar-open' ให้เลื่อน Sidebar ออกมา) */
  .admin-layout.sidebar-open .admin-sidebar {
    left: 0;
  }
}
</style>
